import { DashboardStatsResponse, Options, Resource } from 'services/api';

import Company from './Company.service';

export default class Dashboard extends Company {
  private static instance: Dashboard;

  private constructor(options: Options) {
    /* istanbul ignore next */
    super(options);
    // this related to how typescript transpile this line in es5
    // e.g. var _this = _super.call(this) || this;
  }

  /**
   * This return the singleton instance of the class
   * @param {Options} options
   */
  public static getInstance(options: Options) {
    if (!this.instance) {
      this.instance = new this(options);
    }

    return this.instance;
  }

  /**
   * This returns the dashboard stats
   */
  getStats() {
    const url = this.generateUrl(`/company-portal/${Resource.Company}/stats`);

    return this.makeRequest<DashboardStatsResponse>({
      url,
      method: this._request.Get
    });
  }
}
